import { DrawerBody } from '@chakra-ui/react'

export default DrawerBody
